import { render, staticRenderFns } from "./freightTemplateList.vue?vue&type=template&id=bb98102c"
import script from "./freightTemplateList.vue?vue&type=script&lang=js"
export * from "./freightTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports